var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSpinnerOverlay = function SvgSpinnerOverlay(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 12,
    "data-width-24": 16,
    viewBox: "0 0 12 12",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 6A6 6 0 1 1 0 6a6 6 0 0 1 12 0M1.87 6a4.13 4.13 0 1 0 8.26 0 4.13 4.13 0 0 0-8.26 0",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.065 6c.516 0 .942-.421.862-.932A6 6 0 0 0 6.932.073C6.422-.007 6 .419 6 .935c0 .517.424.925.927 1.041a4.13 4.13 0 0 1 3.097 3.097c.116.503.524.927 1.04.927"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSpinnerOverlay);
export default ForwardRef;